import { StaticModal, createModal } from '@nexelem/modals';
import { useCustomTranslation } from '../../../../../../hooks';
import { Button, Banner } from '@nexelem/components';
import loadingAnimation from '../../../../../../../assets/loadingAnimation.gif';
import { closeOptimizePlanParametersModal, openOptimizePlanParametersModal } from './OptimizeParametersModal';
import { useGanttSimulationOptimize } from './useGanttSimulationOptimize';
import { useSuspenseGetGraphneSimulationParameters } from '../../hooks';

export const OptimizeConfirmModal = () => {
  const { mutateAsync, isPending } = useGanttSimulationOptimize();
  const { data: parameters } = useSuspenseGetGraphneSimulationParameters();

  const { t, tWrapper } = useCustomTranslation('products.simulationPlan');

  const handleOptimize = () => {
    if (parameters.length === 0) {
      mutateAsync([], { onSuccess: () => closeOptimizeConfirmModal() });
    } else {
      closeOptimizeConfirmModal();
      openOptimizePlanParametersModal({
        onSubmit: async (parameterValues) => {
          await mutateAsync(parameterValues);
          closeOptimizePlanParametersModal();
        },
      });
    }
  };

  return (
    <StaticModal maxWidth="lg" onClose={closeOptimizeConfirmModal}>
      <StaticModal.Header withCloseButton={!isPending}>{tWrapper('optimizeProductionPlan')}</StaticModal.Header>
      {isPending ? (
        <StaticModal.Content className="flex flex-col items-center justify-center gap-4 pb-6 text-s18">
          <img alt="Loading" height={90} src={loadingAnimation} width={120} />
          <div className="text-s16 text-text-secondary">{tWrapper('optimizeInProgress')}</div>
        </StaticModal.Content>
      ) : (
        <>
          <StaticModal.Content className="text-s18">
            <p className="mb-6">{tWrapper('optimizeProductionPlanContent')}</p>
            <p className="mb-6">{tWrapper('optimizeProductionPlanContent2')}</p>
            <Banner className="w-full" message={tWrapper('optimizeProductionPlanWarning')} type="warning" />
          </StaticModal.Content>
          <StaticModal.Footer>
            <Button variant="outlined" onClick={closeOptimizeConfirmModal}>
              {t('common.cancel')}
            </Button>
            <Button isLoading={isPending} variant="contained" onClick={handleOptimize}>
              {tWrapper('optimizePlan')}
            </Button>
          </StaticModal.Footer>
        </>
      )}
    </StaticModal>
  );
};

export const { openOptimizeConfirmModal, closeOptimizeConfirmModal } = createModal(OptimizeConfirmModal, {
  name: 'OptimizeConfirmModal',
});
